export const vacationListColumns = [
  { field: 'user', headerName: 'Consultor' },
  { field: 'startDate', headerName: 'Desde' },
  { field: 'endDate', headerName: 'Hasta' },
  { field: 'days', headerName: 'Duración' },
  { field: 'status', headerName: 'Estatus' },
  { field: 'actions', headerName: 'Acciones' },
];
